import { IconSiteMode } from 'components/Shared/Icon/themes/BGH-RD3/iconSiteMode';
import styles from './styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { selectSiteMode, selectChannel } from './selector';
import cn from 'classnames';
import { NO_ELEMENT, rm } from 'utils';
import { SiteMode as SiteModeEnum } from 'models/SiteMode';
import { Button } from 'components/Button';
import { setSiteMode } from 'store/appShell/actions';
import { isLayout, isMobile, isTablet } from 'components/Shared/responsive';

const validChannels = ['GOP'];

export const SiteMode = () => {
  const siteMode = useSelector(selectSiteMode);
  const channel = useSelector(selectChannel);
  const isTabletOrLess = useSelector(isLayout(isMobile, isTablet));
  const dispatch = useDispatch();

  if (!validChannels.includes(channel) || isTabletOrLess) {
    return NO_ELEMENT;
  }

  const changeSiteMode = (siteMode: SiteModeEnum) => () => {
    return dispatch(setSiteMode(siteMode));
  };

  return (
    <div className={styles.siteMode}>
      <IconSiteMode className={styles.icon} />
      <>
        <Button
          appearance="link"
          onClick={changeSiteMode(SiteModeEnum.Private)}
          className={cn(styles.siteModeType, {
            [styles.siteModeSelected]:
              siteMode === SiteModeEnum.Private || siteMode === SiteModeEnum.Unknown
          })}
        >
          {rm('checkout_folder_private')}
        </Button>
        |
        <Button
          appearance="link"
          onClick={changeSiteMode(SiteModeEnum.Company)}
          className={cn(styles.siteModeType, {
            [styles.siteModeSelected]: siteMode === SiteModeEnum.Company
          })}
        >
          {rm('checkout_folder_company')}
        </Button>
      </>
    </div>
  );
};
